import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import NavbarUtente from "./Navbar";
import Footer, { infoUtente, loadFooter } from "./Footer";
import Table from "../../components/Table";
import Checkbox from "../../components/Checkbox";
import Input from "../../components/Input";
import DatePicker from "../../components/DatePicker";
import PopUp from "../../components/PopUp";
import Combobox from "../../components/Combobox";
import Toggle from "../../components/Toggle.jsx";
import Loader from "../../components/Loader";
import jsQR from "jsqr";
import QRCodeGenerator from '../../components/QRCodeGenerator.jsx';
import Alert from "../../components/Alert";
import Button from "../../components/Button.jsx";
import { Printer, Download, Upload, QrCode, ScanLine, Trash2, SquarePen, Info, ClipboardList, ClipboardPaste, RotateCcw } from "lucide-react";

let stati = [];
let impianti = [];

const RowPC = ({ data, onCheckboxChange }) => {
    return (
        <div className="grid grid-cols-8 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
            <div className="flex items-center pl-2 ">
                {data.value.Codice}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.Descrizione}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.Categoria}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.DataInstallazione}
            </div>
            <div className="flex items-center pl-2 " style={{ color: stati.find((s) => s.Nome === data.value.StatoAttuale)?.Colore || 'inherit' }}>
                {data.value.StatoAttuale}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.ProssimaManutenzione}
            </div>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm" style={header.key === "StatoAttuale" ? { color: stati.find((s) => s.Nome === data.value.StatoAttuale)?.Colore || 'inherit' } : {}}>
                                {header.key === "IDImpianto" ? impianti.find(imp => imp.ID === data.value[header.key])?.Nome + (impianti.find(imp => imp.ID === data.value[header.key])?.Descrizione ? ` - ${impianti.find(imp => imp.ID === data.value[header.key])?.Descrizione}` : "") : data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
}

const Cliente = () => {
    const headers = [
        { label: "Nome", key: "Codice" },
        { label: "Descrizione", key: "Descrizione" },
        { label: "Sito", key: "IDImpianto" },
        { label: "Categoria", key: "Categoria" },
        { label: "Data Installazione", key: "DataInstallazione" },
        { label: "Stato Attuale", key: "StatoAttuale" },
        { label: "Prossima Manutenzione", key: "ProssimaManutenzione" }
    ];
    const [dataTable, setDataTable] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isQrCodeVisible, setIsQrCodeVisible] = useState(false);
    const [isAddVisible, setIsAddVisible] = useState(false);
    const [isReportVisible, setIsReportVisible] = useState(false);
    const [dataAdd, setDataAdd] = useState({
        "ID": null,
        "Codice": null,
        "Descrizione": null,
        "IDImpianto": null,
        "IDCategoria": null,
        "DataInstallazione": null
    });
    const [isRowInfoVisible, setIsRowInfoVisible] = useState(false);
    const [dataRow, setDataRow] = useState({});
    const [needConfirmRow, setNeedConfirmRow] = useState(false);
    const [infoCliente, setInfoCliente] = useState({});
    const [selectMacroCat, setSelectMacroCat] = useState([]);
    const [selectedMacroCat, setSelectedMacroCat] = useState(null);
    const [selectSottoCat, setSelectSottoCat] = useState([]);
    const navigate = useNavigate();
    const canvasRef = useRef(null);
    const [scanning, setScanning] = useState(false);
    const [qrCodeContent, setQrCodeContent] = useState("");
    const toggleRef = useRef(null);
    const [stateToggle, setStateToggle] = useState(false);
    const [dataReport, setDataReport] = useState({});
    const [isReassign, setIsReassign] = useState(false);
    const [idAzienda, setIdAzienda] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        if (!isReportVisible) {
            setStateToggle(false);
            setDataReport({});
        }
    }, [isReportVisible]);

    const onload = async () => {
        setIsLoading(true);
        try {
            if (document.cookie.valueOf("IDAzienda") === "") {
                setAlertInfo({ type: "error", text: "Nessuna cliente selezionato, selezionare un cliente per continuare", onClose: () => { setShowAlert(false); navigate('/utente/dash'); }, needConfirm: false });
                setShowAlert(true);
                return;
            }
            setIdAzienda(document.cookie.split("IDAzienda=")[1].split(";")[0]);

            await loadFooter();

            const r1 = await fetch("/getComponenti", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    IDAzienda: document.cookie.split("IDAzienda=")[1].split(";")[0]
                })
            });

            const rd1 = await r1.json();

            if (r1.status === 500) {
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false); navigate('/utente/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setDataTable(rd1.map((d) => ({ value: d, checked: false })));

                const r2 = await fetch("/getInfoAzienda", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente.CodiceDominio,
                        IDAzienda: document.cookie.split("IDAzienda=")[1].split(";")[0]
                    })
                });

                const rd2 = await r2.json();

                if (r2.status === 500) {
                    console.log(rd2.error);
                    setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); navigate('/utente/dash'); }, needConfirm: false });
                    setShowAlert(true);
                }
                else {
                    setInfoCliente(rd2[0]);

                    const r3 = await fetch('/getCategorie', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente["CodiceDominio"]
                        })
                    });
                    const rd3 = await r3.json();
                    if (r3.status === 500) {
                        console.error(rd3.error);
                        setAlertInfo({ type: "error", text: rd3.error, onClose: () => { setShowAlert(false); navigate('/utente/dash'); }, needConfirm: false });
                        setShowAlert(true);
                    } else {
                        setSelectMacroCat(rd3.filter((d) => d["Obsoleta"] === false && d["IDPadre"] === null));
                        setSelectSottoCat(rd3.filter((d) => d["Obsoleta"] === false && d["IDPadre"] !== null));

                        const r4 = await fetch('/getStati', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente["CodiceDominio"]
                            })
                        });
                        const rd4 = await r4.json();
                        if (r4.status === 500) {
                            console.error(rd4.error);
                            setAlertInfo({ type: "error", text: rd4.error, onClose: () => { setShowAlert(false); navigate('/utente/dash'); }, needConfirm: false });
                            setShowAlert(true);
                        } else {
                            stati = rd4;

                            const r5 = await fetch("/getImpiantiByAzienda", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    CodiceDominio: infoUtente["CodiceDominio"],
                                    IDAzienda: document.cookie.split("IDAzienda=")[1].split(";")[0]
                                })
                            });
                            const rd5 = await r5.json();
                            if (r5.status === 500) {
                                console.log(rd5.error);
                                setAlertInfo({ type: "error", text: rd5.error, onClose: () => { window.location.reload() }, needConfirm: false });
                                setShowAlert(true);
                            } else {
                                impianti = rd5.filter(i => i.Obsoleto === false);
                            }
                        }
                    }
                }
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante il caricamento della pagina, riprova più tardi", onClose: () => { setShowAlert(false); navigate('/utente/dash'); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleElimina = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const response = await fetch("/eliminaComponente", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        ID: dataRow.value["ID"]
                    })
                });

                if (response.status === 500) {
                    const rd = await response.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    window.location.reload();
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore durante l'eliminazione del componente, riprova più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare il componente?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const confirmPopUpModifica = async () => {
        if (!dataRow.value["IDCategoria"] || !dataRow.value["DataInstallazione"] || !dataRow.value["ID"] || !dataRow.value["IDImpianto"]) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);
        try {
            const r1 = await fetch("/aggiornaComponente", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    ID: dataRow.value["ID"],
                    Codice: dataRow.value["Codice"],
                    IDCategoria: dataRow.value["IDCategoria"],
                    DataInstallazione: dataRow.value["DataInstallazione"],
                    Descrizione: dataRow.value["Descrizione"],
                    IDAzienda: idAzienda,
                    IDImpianto: dataRow.value["IDImpianto"]
                }),
            });
            if (r1.status === 500) {
                const rd1 = await r1.json();
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante la modifica del componente, riprova più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleImport = () => {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = ".csv";
        fileInput.click();
        fileInput.onchange = (event) => {
            const file = event.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = function (event) {
                const text = event.target.result;
                const rows = text.split("\n").map(row => row.split(",").map(cell => cell.replace(/"/g, "")));
                if (rows.length < 2) {
                    setAlertInfo({ type: "warning", text: "File CSV non valido", onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                    return;
                }
                rows.shift();
                const data = rows[0][0].split(";");
                const isCategoriaValida = selectSottoCat.some(cat => cat.Nome.toLowerCase() === data[4].toLowerCase() && cat.Descrizione.toLowerCase() === data[5].toLowerCase());
                if (data.length !== 7 || !isCategoriaValida) {
                    setAlertInfo({ type: "error", text: "Le informazioni della categoria sono errate. Inserire i valori così come stati inseriti in fase di creazione della categoria", onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                    return;
                }
                const isImpiantoValido = impianti.some(imp => imp.Nome.toLowerCase() === data[2].toLowerCase() && imp.Descrizione.toLowerCase() === data[3].toLowerCase());
                if (!isImpiantoValido) {
                    setAlertInfo({ type: "error", text: "Le informazioni del sito sono errate. Inserire i valori così come stati inseriti in fase di creazione del sito", onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                    return;
                }
                setDataAdd({
                    Codice: data[0],
                    Descrizione: data[1],
                    IDImpianto: impianti.find(imp => imp.Nome === data[2] && imp.Descrizione === data[3])?.ID || null,
                    IDCategoria: selectSottoCat.find(cat => cat.Nome === data[4] && cat.Descrizione === data[5])?.ID || null,
                    DataInstallazione: data[6],
                });
                setAlertInfo({ type: "success", text: "Importazione avvenuta con successo. Completa i campi mancanti e salva.", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            };
            reader.onerror = function () {
                console.error("Errore durante la lettura del file CSV");
                setAlertInfo({ type: "error", text: "Errore durante la lettura del file CSV", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            };

            reader.readAsText(file);
        };
    };

    const handleExport = () => {
        if (!dataRow.value.IDCategoria || !dataRow.value.DataInstallazione || !dataRow.value.IDImpianto) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        const data = [
            ["Codice", "Descrizione", "Nome Impianto", "Descrizione Impianto", "Nome Categoria", "Descrizione Categoria", "Data Installazione"],
            [dataRow.value.Codice, dataRow.value.Descrizione, impianti[dataRow.value.IDImpianto]?.Nome || "", impianti[dataRow.value.IDImpianto]?.Descrizione || "", selectSottoCat[dataRow.value.IDCategoria]?.Nome || "", selectSottoCat[dataRow.value.IDCategoria]?.Descrizione || "", dataRow.value.DataInstallazione]
        ];
        const filename = "Export_Articolo.csv";

        // Crea il contenuto del CSV
        const csvContent = data
            .map(row => row.map(cell => `"${cell}"`).join(";"))
            .join("\n"); // Unisci le righe con newline

        // Crea un blob con il contenuto CSV
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        // Crea un link per scaricare il file
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute("download", filename);

        // Aggiungi e clicca il link per forzare il download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const confirmPopUpAdd = async () => {
        if (!dataAdd.IDCategoria || !dataAdd.DataInstallazione || !dataAdd.ID || !dataAdd.IDImpianto) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const r1 = await fetch("/addComponente", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    ID: dataAdd.ID,
                    IDAzienda: Number(idAzienda),
                    Codice: dataAdd.Codice || "",
                    IDCategoria: dataAdd.IDCategoria,
                    DataInstallazione: dataAdd.DataInstallazione,
                    Descrizione: dataAdd.Descrizione || "",
                    IDImpianto: dataAdd.IDImpianto
                }),
            });
            if (r1.status === 500) {
                const rd1 = await r1.json();
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante l'aggiunta del componente", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleScanCode = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: { ideal: 'environment' }
                }
            });
            const video = document.querySelector('video#scan');
            video.srcObject = stream;
            video.removeAttribute('hidden');
            setScanning(true);
            setQrCodeContent("");

            requestAnimationFrame(detectQRCode);
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nella lettura", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
        }
    };

    const detectQRCode = async () => {
        const video = document.querySelector('video#scan');
        const canvas = canvasRef.current;
        try {
            const ctx = canvas.getContext('2d');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            try {
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height);
                if (code) {
                    const tracks = video.srcObject?.getTracks();
                    tracks?.forEach(track => track.stop());
                    setScanning(false);
                    scanSuccess({ codice: code.data });
                } else {
                    requestAnimationFrame(detectQRCode);
                }
            } catch (error) {
                console.log(error);
                requestAnimationFrame(detectQRCode);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleStopScan = () => {
        const video = document.querySelector('video#scan');
        const stream = video.srcObject;
        const tracks = stream.getTracks();

        tracks.forEach(function (track) {
            track.stop();
        });

    };

    const scanSuccess = async ({ codice = null }) => {
        if (!codice && qrCodeContent === '') {
            setAlertInfo({ type: "warning", text: "Nessun codice rilevato", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            if (isReassign) {
                const r = await fetch("/checkCodiceQr", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceQr: codice || qrCodeContent,
                    })
                });

                if (r.status === 500 || r.status === 401) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                } else if (r.status === 200) {
                    const pass = async () => {
                        const r2 = await fetch('/aggiornaIDComponente', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente.CodiceDominio,
                                ID: dataRow.value.ID,
                                NuovoID: codice || qrCodeContent
                            })
                        });
                        if (r2.status === 500) {
                            const rd2 = await r2.json();
                            console.log(rd2.error);
                            setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                            setShowAlert(true);
                        }
                        else {
                            setAlertInfo({ type: "success", text: "Riassegnazione avvenuta con successo", onClose: () => { setShowAlert(false); window.location.reload(); }, needConfirm: false });
                            setShowAlert(true);
                            setIsReassign(false);
                        }
                    };
                    setAlertInfo({ type: "warning", text: "Sei sicuro di voler riassegnare il codice QR? Questa è un'operazione irreversibile", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
                    setShowAlert(true);
                }
            }
            else {
                const r = await fetch("/checkCodiceQr", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceQr: codice || qrCodeContent,
                    })
                });

                if (r.status === 500 || r.status === 401) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                } else if (r.status === 200) {
                    setDataAdd({ ...dataAdd, ID: codice || qrCodeContent });
                    setIsQrCodeVisible(false);
                }
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante la scansione del codice QR", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleAddReport = async () => {
        if (dataReport.DataInizio === "" || (stateToggle === true && dataReport.DataFine === "")) {
            setAlertInfo({ type: "error", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);
        try {
            const r1 = await fetch("/addReport", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    IDUtente: infoUtente["ID"],
                    IDAzienda: document.cookie.split("IDAzienda=")[1].split(";")[0],
                    DataInizio: dataReport.DataInizio,
                    DataFine: stateToggle ? dataReport.DataFine : null
                }),
            });
            if (r1.status !== 200) {
                const rd1 = await r1.json();
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setAlertInfo({ type: "success", text: "Report creato con successo", onClose: () => { setShowAlert(false); window.location.reload(); }, needConfirm: false });
                setShowAlert(true);
                setIsReportVisible(false);
                setDataReport({});
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante l'invio del report, riprova più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    }

    return (
        <div className="h-[100svh]">
            <NavbarUtente page={"CLIENTE"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4 pb-24">
                <div className="flex justify-center my-2 rounded-lg bg-gray-200 dark:bg-neutral-800 py-2">
                    <div className="w-[80%] md:w-[50%]">
                        <p className="flex justify-between">
                            Nome :
                            <span className="font-semibold">{infoCliente.Nome}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Email :
                            <span className="font-semibold">{infoCliente.Email}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Indirizzo :
                            <span className="font-semibold">{infoCliente.Indirizzo}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Città :
                            <span className="font-semibold">{infoCliente.Citta}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            CAP :
                            <span className="font-semibold">{infoCliente.Cap}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Provincia :
                            <span className="font-semibold">{infoCliente.Provincia}</span>
                        </p>
                        {infoCliente.SIM && infoCliente.SIM === true && (
                            <>
                                <p className="flex justify-between mt-1">
                                    Password SIM :
                                    <span className="font-semibold">{infoCliente.Password}</span>
                                </p>
                                <p className="flex justify-between mt-1">
                                    Scadenza SIM :
                                    <span className="font-semibold">{infoCliente.ScadenzaSIM}</span>
                                </p>
                            </>
                        )}
                    </div>
                </div>
                <Button type="hollow" classes="w-full my-2" onClick={() => setIsReportVisible(true)}>
                    CREA REPORT <ClipboardList size={16} strokeWidth={2} className="inline-block ml-1" />
                </Button>
                <Table keyForPreview={["Codice", "Descrizione"]}
                    headers={headers}
                    data={dataTable}
                    setData={setDataTable}
                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                    itemsPC={6}
                    itemsMobile={3}
                    needResearch={true}
                    classes="mt-2"
                    clickableRow={true}
                    archiveClickable={false}
                    actionRow={(row, rowIndex) => {
                        // Trasforma la data da GG/MM/AAAA a AAAA-MM-GG
                        let dataInstallazione = row.value.DataInstallazione;
                        const [gg, mm, aaaa] = dataInstallazione.split("/");
                        let dataISO = `${aaaa}-${mm}-${gg}`;
                        setDataRow({ ...row, value: { ...row.value, DataInstallazione: dataISO } });
                        setIsRowInfoVisible(true);
                    }}
                    needArchive={true}
                    archiveKey="Obsoleto"
                    archiveValue={true}
                    needAdd={true}
                    addAction={() => { setIsAddVisible(true) }}
                />
                <PopUp title={"Aggiungi Articolo"}
                    isVisible={isAddVisible}
                    setIsVisible={setIsAddVisible}
                    needConfirm={true}
                    confirmAction={confirmPopUpAdd}
                    cancelAction={() => { setIsAddVisible(false); setDataAdd({}); setSelectedMacroCat(null); }}
                >
                    <div className="flex justify-center items-center w-full">
                        <Button type="hollow" onClick={handleImport}>
                            IMPORT <Download size={16} strokeWidth={2} className="inline-block ml-1" />
                        </Button>
                    </div>
                    <div className="flex flex-col items-center">
                        <Input
                            label="Codice"
                            value={dataAdd.Codice || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, Codice: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Descrizione"
                            value={dataAdd.Descrizione || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, Descrizione: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Combobox
                            options={impianti.filter(i => i.ID !== 0).map((d) => ({
                                label: d["Nome"] + (d["Descrizione"] ? ` - ${d["Descrizione"]}` : ""),
                                value: d["ID"]
                            }))}
                            onChange={(value) => setDataAdd({ ...dataAdd, IDImpianto: value })}
                            label="Sito *"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                            readOnly={false}
                            defaultValue={dataAdd["IDImpianto"]}
                        />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 w-[80%] md:w-[70%] mt-2">
                            <Combobox
                                options={selectMacroCat.map((item) => ({
                                    label: item["Nome"],
                                    value: item["ID"]
                                }))}
                                onChange={(value) => { setSelectedMacroCat(value) }}
                                label="Macro-Categoria"
                                classes="w-full"
                                disabled={false}
                                error={false}
                                readOnly={false}
                                defaultValue={selectedMacroCat || selectSottoCat.find(item => item.ID === dataAdd["IDCategoria"])?.IDPadre || null}
                            />
                            <Combobox
                                options={selectSottoCat.filter(item => item["IDPadre"] === (selectedMacroCat || selectSottoCat.find(item => item.ID === dataAdd["IDCategoria"])?.IDPadre || null)).map((item) => ({
                                    label: item["Nome"] + (item["Descrizione"] ? ` - ${item["Descrizione"]}` : ""),
                                    value: item["ID"]
                                }))}
                                onChange={(value) => setDataAdd({ ...dataAdd, IDCategoria: value })}
                                label="Categoria *"
                                classes="w-full"
                                disabled={!selectedMacroCat && !selectSottoCat.some(item => item.ID === dataAdd["IDCategoria"])}
                                error={false}
                                readOnly={false}
                                defaultValue={dataAdd["IDCategoria"]}
                            />
                        </div>
                        <DatePicker
                            label="Data Installazione *"
                            value={dataAdd.DataInstallazione || ""}
                            setValue={(value) => { setDataAdd({ ...dataAdd, DataInstallazione: value }); console.log("Data Installazione:", value) }}
                            error={false}
                            disabled={false}
                            classes="w-[80%] md:w-[70%] mt-2"
                        />
                        <p className="flex items-center justify-between w-[80%] md:w-[70%] my-4">
                            QRCode *:
                            <QrCode size={30} strokeWidth={2} className="inline-block cursor-pointer text-blue-600" onClick={() => setIsQrCodeVisible(true)} />
                        </p>
                    </div>
                </PopUp>
                <PopUp title={needConfirmRow ? "Modifica Articolo" : ""}
                    isVisible={isRowInfoVisible}
                    setIsVisible={setIsRowInfoVisible}
                    needConfirm={needConfirmRow}
                    confirmAction={confirmPopUpModifica}
                    cancelAction={() => { setNeedConfirmRow(false); setDataRow({}); setSelectedMacroCat(null); }}
                >
                    {needConfirmRow && (
                        <>
                            <div className="flex justify-center items-center w-full">
                                <Button type="hollow" onClick={handleExport}>
                                    EXPORT <Upload size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                            </div>
                            <div className="flex flex-col items-center">
                                <Input
                                    label="Codice"
                                    value={dataRow.value["Codice"]}
                                    setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Codice: value } })}
                                    type="text"
                                    classes="w-[80%] md:w-[70%] mt-2"
                                    disabled={false}
                                    error={false}
                                />
                                <Input
                                    label="Descrizione"
                                    value={dataRow.value["Descrizione"]}
                                    setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Descrizione: value } })}
                                    type="text"
                                    classes="w-[80%] md:w-[70%] mt-2"
                                    disabled={false}
                                    error={false}
                                />
                                <Combobox
                                    options={impianti.filter(i => i.ID !== 0).map((d) => ({
                                        label: d["Nome"] + (d["Descrizione"] ? ` - ${d["Descrizione"]}` : ""),
                                        value: d["ID"]
                                    }))}
                                    onChange={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, IDImpianto: value } })}
                                    label="Sito *"
                                    classes="w-[80%] md:w-[70%] mt-2"
                                    disabled={false}
                                    error={false}
                                    readOnly={false}
                                    defaultValue={dataRow.value["IDImpianto"]}
                                />
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 w-[80%] md:w-[70%] mt-2">
                                    <Combobox
                                        options={selectMacroCat.map((item) => ({
                                            label: item["Nome"],
                                            value: item["ID"]
                                        }))}
                                        onChange={(value) => { setSelectedMacroCat(value) }}
                                        label="Macro-Categoria"
                                        classes="w-full"
                                        disabled={false}
                                        error={false}
                                        readOnly={false}
                                        defaultValue={selectedMacroCat || selectSottoCat.find(item => item.ID === dataRow.value["IDCategoria"])?.IDPadre || null}
                                    />
                                    <Combobox
                                        options={selectSottoCat.filter(item => item["IDPadre"] === (selectedMacroCat || selectSottoCat.find(item => item.ID === dataRow.value["IDCategoria"])?.IDPadre)).map((item) => ({
                                            label: item["Nome"] + (item["Descrizione"] ? ` - ${item["Descrizione"]}` : ""),
                                            value: item["ID"]
                                        }))}
                                        onChange={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, IDCategoria: value } })}
                                        label="Categoria *"
                                        classes="w-full"
                                        disabled={!selectedMacroCat && !selectSottoCat.some(item => item.ID === dataRow.value["IDCategoria"])}
                                        error={false}
                                        readOnly={false}
                                        defaultValue={dataRow.value["IDCategoria"]}
                                    />
                                </div>
                                <DatePicker
                                    label="Data Installazione *"
                                    value={dataRow.value["DataInstallazione"]}
                                    setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, DataInstallazione: value } })}
                                    error={false}
                                    disabled={false}
                                    classes="w-[80%] md:w-[70%] mt-2"
                                />
                            </div>
                        </>
                    )}
                    {!needConfirmRow && (
                        <>
                            <div className="grid grid-cols-2 mt-2 gap-2">
                                <Button type="hollow" onClick={handleElimina}>
                                    ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                                <Button type="hollow" onClick={() => setNeedConfirmRow(true)}>
                                    MODIFICA <SquarePen size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                                <Button type="hollow" onClick={() => { setIsReassign(true); setIsQrCodeVisible(true); }}>
                                    CAMBIA CODICE <RotateCcw size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                                <Button type="hollow" onClick={() => { document.cookie = `IDComponente=${dataRow.value["ID"]}; path=/;`; navigate("/utente/articolo") }}>
                                    APRI ARTICOLO <Info size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                            </div>
                        </>
                    )}
                </PopUp>
                <PopUp title={"QRCode"}
                    isVisible={isQrCodeVisible}
                    setIsVisible={setIsQrCodeVisible}
                    needConfirm={true}
                    confirmAction={scanSuccess}
                    cancelAction={() => { setIsQrCodeVisible(false); scanning && handleStopScan(); setQrCodeContent(null); isReassign && setIsReassign(false); }}
                >
                    <div className="flex flex-col items-center justify-center">
                        <Button type="hollow" classes="w-[80%] md:w-[60%]" onClick={() => {
                            setScanning(true);
                            handleScanCode();
                        }}>
                            SCANSIONA QRCODE <ScanLine size={16} strokeWidth={2} className="inline-block ml-2" />
                        </Button>
                        <div className='flex justify-center mt-4'>
                            {
                                scanning && (
                                    <>
                                        <video muted autoPlay playsInline hidden id="scan" className="rounded w-[80%] md:w-[60%] h-[80%] md:h-[60%]"></video>
                                        <canvas
                                            ref={canvasRef}
                                            style={{ display: 'none' }}
                                            hidden
                                        />
                                    </>
                                )
                            }
                        </div>
                        <div className="relative flex items-center justify-center w-full my-4">
                            <div className="absolute w-full h-1 bg-gray-200 dark:bg-neutral-800 rounded"></div>
                            <span className="relative px-3 bg-gray-100 dark:bg-neutral-900 ">oppure inserisci il codice manualmente</span>
                        </div>
                        <Input
                            label="Codice"
                            value={qrCodeContent || ""}
                            setValue={setQrCodeContent}
                            type="text"
                            classes="w-[80%] md:w-[60%] mt-2"
                            disabled={false}
                            error={false}
                        />
                    </div>
                </PopUp>
                <PopUp title={"Crea Report"}
                    isVisible={isReportVisible}
                    setIsVisible={setIsReportVisible}
                    needConfirm={false}
                >
                    <div className="flex flex-col items-center">
                        <div className="w-full flex justify-between items-center text-sm">
                            Giorno singolo
                            <Toggle ref={toggleRef} onToggleChange={(value) => setStateToggle(value)} classes="mx-2" isDouble={true} />
                            Intervallo di giorni
                        </div>
                        <DatePicker
                            label={stateToggle ? "Data Inizio Intervento *" : "Data Intervento *"}
                            value={dataReport.DataInizio || ""}
                            setValue={(value) => setDataReport({ ...dataReport, DataInizio: value })}
                            error={false}
                            disabled={false}
                            classes="w-[80%] md:w-[70%] mt-2"
                        />
                        {stateToggle && (
                            <DatePicker
                                label="Data Fine Intervento *"
                                value={dataReport.DataFine || ""}
                                setValue={(value) => setDataReport({ ...dataReport, DataFine: value })}
                                error={false}
                                disabled={false}
                                classes="w-[80%] md:w-[70%] mt-2"
                            />
                        )}
                        <Button type="hollow" onClick={handleAddReport} classes="w-full mt-2">
                            INVIA REPORT A MANAGER <ClipboardPaste size={16} strokeWidth={2} className="inline-block ml-1" />
                        </Button>
                    </div>
                </PopUp>
            </div>
            <Footer />
        </div>
    )
};

export default Cliente;